// import React from 'react';

// const logos = [
//   // Replace these with actual logo URLs from Unsplash or your image directory
//   '/images/c-logo.png',
//   '/images/c-logo3.jpg',
//   '/images/c-logo2.jpeg',
//   '/images/c-logo4.jpg',

// ];

// const LogosGallery = () => {
//   return (
//     <div className="min-h-screen bg-white py-10 px-4">
//       <h2 className="text-2xl font-semibold text-center mb-8">Our Partners</h2>
//       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-6 place-items-center">
//         {logos.map((logo, index) => (
//           <div key={index} className="w-[150px] h-[80px] flex items-center justify-center p-2 border rounded shadow-sm bg-white hover:shadow-md transition">
//             <img src={logo} alt={`Logo ${index + 1}`} className="max-h-full max-w-full object-cover" />
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default LogosGallery;

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const logos = [
  {
    src: '/images/c-logo.png',
    // name: 'Bahria Town',
  },
  {
    src: '/images/c-logo3.jpg',
    // name: 'Sitara Hamza (Pvt) LTD',
  },
  {
    src: '/images/c-logo2.jpeg',
    // name: 'Nizam Sons (Pvt) LTD',
  },
  {
    src: '/images/c-logo4.jpeg',
    // name: 'Toor Associates (Pvt) LTD',
  },
   {
    src: '/images/c-logo5.png',
    // name: 'United Engineering Construction',
  },
  {
    src: '/images/c-logo6.jpg',
    name: 'PAK HK DEVELOPERS',
  },
  {
    src: '/images/c-logo7.png',
    name: 'Five Star Textile Industries (Pvt) LTD',
  },{
    src: '/images/c-logo8.jpeg',
    name: 'Five Star Textile Industries (Pvt) LTD',
  },{
    src: '/images/c-logo9.jpg',
    name: 'Variant Architects',
  },{
    src: '/images/c-logo10.jpeg',
    name: 'Anjuman-e-Mohammadi',
  },
];

const LogosGallery = () => {
   useEffect(() => {
      AOS.init({ duration: 1000 });
    }, []);
  return (
    <div className="min-h-[50vh] bg-white py-10 px-4">
      <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">Our Partners</h2>
      
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 place-items-center">
        {logos.map((logo, index) => (
          <div
            key={index}
            className="w-[270px] h-[200px] flex flex-col items-center justify-center rounded shadow-sm bg-white hover:shadow-lg transition duration-300"
          data-aos="zoom-in"
          >
            <img
              src={logo.src}
              alt={`Partner Logo ${index + 1}`}
              className="w-[270px] h-[160px] object-contain mb-3"
            />
            <p className="text-base text-center font-medium text-gray-700">{logo.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogosGallery;

